/// <amd-module name="Repos/Changes/Components/Diff/DiffContext" />
import * as React from "react";
import { DiffViewerOrientation, DiffViewerSide } from "Repos/Common/Contracts/VersionControlViewModel";

type DiffContextProps = {
    orientation: DiffViewerOrientation;
};

export const DiffViewerContext = React.createContext<DiffContextProps>({ orientation: DiffViewerOrientation.SideBySide });

type DiffViewerSideContextProps = {
    side: DiffViewerSide;
};

export const DiffViewerSideContext = React.createContext<DiffViewerSideContextProps>({ side: DiffViewerSide.None });
